<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";

    import { stepperControllerContextToken } from "./context_tokens";
    import StepperController from "./StepperController";

    export let stepperController: StepperController;
    const currentStep$ = stepperController.currentStep$;

    setTypedContext(stepperControllerContextToken, stepperController);
</script>

<div class="gw-stepper" data-gw-step-name={$currentStep$?.name}>
    <slot />
</div>

<style lang="postcss">
    .gw-stepper {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }
</style>
